/*
 * @Description  : 环境判断相关文件
 * @usage        : 环境判断相关文件
 * @FilePath: /vise/packages/app-share/src/utils/env.ts
 */
import { ENameSpaceTypes, EDockerEnvTypes } from '@/constants/service';

/**
 * 判断是否开发环境
 */
export const IS_DEV = import.meta.env.DEV;

/**
 * 判断是否 SSR 环境
 */
export const IS_SSR = import.meta.env.SSR;

/**
 * 判断是否浏览器环境
 *
 * @return {*}  {boolean}
 */
export const checkIsInBrowser = (): boolean => typeof window !== 'undefined';

/**
 * 根据域名判断是否是测试环境（仅能客户端环境中调用）
 *
 * @return {*}  {boolean}
 */
export const checkIsTestEnvAndInBrowser = (): boolean => checkIsInBrowser() && /test/.test(window.location.host);

/**
 * 粗略判断是否 SSR 且是否在 DevCloud 环境
 *
 * @return {*}  {boolean}
 */
export const checkIsSsrAndInDevCloud = (): boolean => {
  if (!IS_SSR) return false;
  return Boolean(Number(import.meta.env.VITE_DEV_CLOUD));
};


/**
 * 判断是否 SSR 阶段且是否在 DOCKER 环境
 *
 * @return {*}  {boolean}
 */
export const checkIsInDocker = (): boolean => {
  if (!IS_SSR) return false;
  // eslint-disable-next-line @typescript-eslint/dot-notation
  const DOCKER_ENV = process.env['DOCKER_ENV'] || '';
  const envTypes = [
    EDockerEnvTypes.pre,
    EDockerEnvTypes.test,
    EDockerEnvTypes.formal,
    ...(DOCKER_ENV ? [DOCKER_ENV] : []),
  ] as (string | undefined)[];
  // eslint-disable-next-line @typescript-eslint/dot-notation
  return envTypes.includes(process.env['DOCKER_ENV']);
};


/**
 * 判断是否 SSR 阶段且是否在正式服务环境
 *
 * @return {*}  {boolean}
 */
export const checkIsSsrAndInFormalDocker = (): boolean => {
  if (!IS_SSR) return false;
  // eslint-disable-next-line @typescript-eslint/dot-notation
  return EDockerEnvTypes.formal === process.env['DOCKER_ENV'];
};

/**
 * 根据运行环境判断北极星服务命名空间
 *
 * @export
 * @returns {ENameSpaceType}
 */
export function getPolarisNamespace(): ENameSpaceTypes {
  if (!IS_SSR) return ENameSpaceTypes.Unknown;
  // eslint-disable-next-line @typescript-eslint/dot-notation
  return EDockerEnvTypes.formal === process.env['DOCKER_ENV']
    ? ENameSpaceTypes.Production
    : ENameSpaceTypes.Development;
}
